<template>
    <ui-PanelTab valueIco="favorites" :title="$dicc.favorites.title" @togglePanel="$emit('update:show', !show)">
        <div class="devices">
            <Device
                v-for="device in $fns.sortByProperty(devices, 'name')"
                :key="`${device.installation_ref}_${device.reference}`"
                v-show="device.is_favourite == '1'"
                :ref="`Device_${device.reference}`"
                :device="device"
                :subName="`${getLocationName(device)} - ${getSpaceName(device)}`"
                @click="$emit('deviceClick', $event)"
            >
            </Device>
        </div>
    </ui-PanelTab>
</template>

<script>
    import Device from '../components/Device';
    import Installation from '../models/Installation';
    import { MqttMixin } from '../mixins/MqttMixin';
    import { mapState } from 'vuex';

    export default {
        mixins: [MqttMixin],
        components: { Device },
        name: 'Favorites',
        props: {
            show: Boolean,
        },
        data: function() {
            return {
                installations: [],
                devices: [],
            };
        },
        mounted() {
            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });
        },
        methods: {
            init(callbackStart, callbackEND) {
                if (!this.show) return;
                this.getInstalations(callbackStart, callbackEND);
                this.getDevices(callbackStart, callbackEND);
            },

            getDevices: function(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getFavourites(
                    (data) => {
                        this.devices = data.entity;
                        this.devices.forEach((x) => {
                            if (!this.isSubscribe(x.installation_ref)) this.subscribe(x.installation_ref);
                            if (callbackStart) callbackStart();
                            this.getStatus(x.installation_ref, null, null, callbackEND);
                        });
                    },
                    null,
                    callbackEND
                );
            },

            getInstalations: function(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getInstallations(
                    null,
                    (data) => {
                        this.installations = data.entity;
                        this.installations.forEach((x) => {
                            if (!this.$store.state.globalStatus[x.reference])
                                this.$store.commit('update', {
                                    [x.reference]: new Installation(),
                                });
                        });
                        if (callbackEND) callbackEND();
                    },
                    callbackEND
                );
            },

            getLocationName: function(device) {
                let installation = this.installations.find((x) => x.reference === device.installation_ref);
                if (!installation) return;

                let location_id = installation.location_id;
                return this.locations.find((x) => x.id === location_id).name || this.$dicc.locations.default;
            },

            getSpaceName: function(device) {
                return this.spaces.find((x) => x.id === device.space_id).name || this.$dicc.spaces.default;
            },
        },
        computed: {
            ...mapState({
                spaces(state) {
                    return Object.values(state.spaces) || [];
                },
                locations(state) {
                    return Object.values(state.locations) || [];
                },
            }),
        },
        watch: {
            show: {
                immediate: true,
                handler(value) {
                    this.init();
                },
            },
        },
    };
</script>
